import React from 'react';
import './index.css';
import firebase from 'firebase';
import 'reactfire/dist/reactfire.min.js';
import 'react-anything-sortable/sortable.css';
import { render } from 'react-dom';
import { Router, Route, browserHistory } from 'react-router';

import App from './App';
import CustomerList from './CustomerList';
import Customer from './Customer';

var config = {
  apiKey: "AIzaSyAfBltFZFknx9V5mPfgzGy_PuhzvMI3M_s",
  authDomain: "mbtv-acbbf.firebaseapp.com",
  databaseURL: "https://mbtv-acbbf.firebaseio.com",
  storageBucket: "mbtv-acbbf.appspot.com"
};
firebase.initializeApp(config);

var database = firebase.database();
var storage = firebase.storage();

render(
  <Router history={browserHistory}>
    <Route path="/" component={App} database={database}>
      <Route path="customers/:customerID" component={Customer} database={database} storage={storage} />
      <Route path="customers" component={CustomerList} database={database} />
    </Route>
  </Router>,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/